import { styled } from 'styled-components';
import { breakpoint, spacing } from 'styles/helpers';
import { grid } from 'styles/mixins';

const IMAGE_WIDTH = '140px';

export const ContentWrapper = styled.div`
    ${grid.twoColumnFitContentInFirst};
    border-top: ${({ theme }) => theme.border.default};

    ${breakpoint.mobile} {
        row-gap: ${spacing.xl};
    }
`;

export const Wrapper = styled.div`
    align-items: flex-start;
    display: flex;
    gap: ${spacing.xl};
    padding: ${spacing.xl} 0 ${spacing['2xl']};
    width: 100%;

    ${breakpoint.mobile} {
        flex-direction: row-reverse;
        margin-top: ${spacing.s};
        padding: 0;
    }
`;

export const InputsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing.s};
    padding-bottom: ${spacing['2xl']};

    ${breakpoint.mobile} {
        margin-top: ${spacing.s};
        padding-bottom: 0;
    }
`;

export const StyledAxisIcon = styled.img`
    min-width: ${IMAGE_WIDTH};
    object-fit: contain;
    padding-top: ${spacing.xl};
    width: ${IMAGE_WIDTH};
`;
